import NestedForm from "@stimulus-components/rails-nested-form/dist/stimulus-rails-nested-form.umd.js"

export default class extends NestedForm {
  static values = {
    newRecordPlaceholder: {
      type: String,
      default: "NEW_PAYMENT_INSTALLMENT_RECORD"
    }
  }

  add (e) {
    e.preventDefault()

    const content = this.templateTarget.innerHTML.replaceAll(
      this.newRecordPlaceholderValue,
      new Date().getTime().toString()
    )
    this.targetTarget.insertAdjacentHTML("beforebegin", content)

    const event = new CustomEvent("rails-nested-form:add", { bubbles: true })
    this.element.dispatchEvent(event)
  }
}
